/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search terms..." |
*
* @param {Knp_Lookup_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_search_placeholder = /** @type {((inputs?: Knp_Lookup_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des termes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Suchbegriffe...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termini di ricerca...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поисковые запросы...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Términos de búsqueda...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索词……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("検索用語...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खोज शब्द...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Termos de pesquisa...")
	return /** @type {LocalizedString} */ ("Search terms...")
});